export enum LoadingState {
  initial = "initial",
  loading = "loading",
  loaded = "loaded",
  failed = "failed",
}
